import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setNewsActive, setNewsList} from "./reducer";
import {useGetNewsDetail, useQryNoticePage} from "../../../api/cmsNotice";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import {useQueryParam} from "../../../hooks";

const Context = createContext(initialState);

function NewsController() {
  const { state, dispatch } = useNewsContext();
  const { getNews } = useQryNoticePage({ flag: '0' });

  const navigateTo = useNavigateTo();
  
  const _getNewsDetail = () => {
  
  };
  
  const getNewsList = async () => {
    let { data } = await getNews();
    
    if (data) {
      data.records = data.records.map(item => {
        item.active = false;
        return item;
      });
      
      dispatch(setNewsList(data));
    }
  };
  
  const selectNews = (active) => {
    let data = { ...state.newsList };
    data.records[active].active = !data.records[active].active;
    dispatch(setNewsList(data));
  };
  
  const gotoNewsDetail = (item) => {
    navigateTo('/newsDetail' + '?noticeId=' + item.noticeId);
  };
  
  return {
    getNewsList,
    selectNews,
    gotoNewsDetail
  };
  
}

function useNewsContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useNewsContext, NewsController};

export default function NewsContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      initialState={initialState}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
